import { createI18n } from 'vue-i18n'
import enAnniversaries from '@/i18n/en/anniversaries.js'
import enDefault from '@/i18n/en/default.js'
import enForm from '@/i18n/en/form.js'
import enGdpr from '@/i18n/en/gdpr.js'
import enResources from '@/i18n/en/resource.js'
import enSocials from '@/i18n/en/socials'

import frAnniversaries from '@/i18n/fr/anniversaries.js'
import frDefault from '@/i18n/fr/default.js'
import frForm from '@/i18n/fr/form.js'
import frGdpr from '@/i18n/fr/gdpr.js'
import frResources from '@/i18n/fr/resource.js'
import frSocials from '@/i18n/fr/socials.js'

export default createI18n({
	locale: 'fr',
	fallbackLocale: 'fr',
	messages: {
		en: {
			...enDefault,
			anniversaries: enAnniversaries,
			form: enForm,
			gdpr: enGdpr,
			resources: enResources,
			socials: enSocials,
		},
		fr: {
			...frDefault,
			anniversaries: frAnniversaries,
			form: frForm,
			gdpr:frGdpr,
			resources: frResources,
			socials: frSocials,
		}
	}
})
